<div class="household-header" *ngIf="isHouseHoldVisible">
  <p class="color-primary">
    {{ "Household ID" | translate }}:
    <b>{{ householdId }}</b>
  </p>
</div>
